import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import i18n from './i18n'

Vue.config.productionTip = false;

// API and Axios
let apiUrl = process.env.VUE_APP_API_URL,
    prodApiUrl = process.env.VUE_APP_PRODUCTION_API_URL;
window.apiUrl = process.env.NODE_ENV === "production" ? (prodApiUrl ? prodApiUrl : apiUrl) : apiUrl;

import axios from 'axios'
axios.defaults.baseURL = window.apiUrl;
let apiKey = process.env.VUE_APP_API_KEY;
if (apiKey){
    axios.defaults.headers.common['x-api-key'] = apiKey;
}
window.axios = axios

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount("#app");
